import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { Msg, Button } from 'react-weui';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
//单头自定义字段
import HeadCustField from 'components/headCustField';
//单身自定义字段
import BodydCustField from 'components/bodyCustField';
import CustFieldService from 'services/custField';
import AppSelect from '../components/select';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import EnumService from 'services/enum2';
import IqcService from 'services/iqc';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import ModalService from 'services/modal';
import CommonFns from 'functions/common.ts';
import Download from 'components/download.js';
import Big from 'big.js';
const isBig = Util.isBig;

const styles = theme => ({
  paper: {
    margin: '10px',
    width: '90vw'
  },
  editWrap: {
    position: 'absolute',
    top: '16px',
    right: '16px'
  }
});

function IqcDetail(props) {
  const Config = {
    purchase: {
      title: '来料检验单详情',
      apiPath: '/verify/order/getDetail',
      publishApiPath: '/verify/order/publish',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        { mainKey: 'B02_Verify_Status', subKey: 'status', value: 'statusName' },
        {
          mainKey: 'B02_Verify_Result_Flag',
          subKey: 'resultFlag',
          value: 'resultFlagName'
        },
        {
          mainKey: 'B02_Verify_SourceOrderType',
          subKey: 'sourceOrderType',
          value: 'sourceOrderTypeName'
        },
        {
          mainKey: 'B02_Order_Sync_Status',
          subKey: 'syncStatus',
          value: 'syncStatusName'
        }
      ],
      idField: 'vfoXkNo',
      wfmCode: '1008',
      custFieldBillType: 15 //自定义字段单别
    },
    sale: {
      title: '客户来料检验单详情',
      apiPath: '/verify/customerOrder/getDetail',
      // deleteApiPath: '/cCostsheetOrder/delete',
      customerNameKey: 'companyName',
      vendorNameKey: 'innerCustomerName',
      arrEnumField: [
        { mainKey: 'B02_Verify_Status', subKey: 'status', value: 'statusName' },
        {
          mainKey: 'B02_Verify_Result_Flag',
          subKey: 'resultFlag',
          value: 'resultFlagName'
        },
        {
          mainKey: 'B02_Verify_SourceOrderType',
          subKey: 'sourceOrderType',
          value: 'sourceOrderTypeName'
        },
        {
          mainKey: 'B02_Order_Sync_Status',
          subKey: 'syncStatus',
          value: 'syncStatusName'
        }
      ],
      idField: 'vfoXkNo',
      custFieldBillType: 15 //自定义字段单别
    }
  };
  const { state, dispatch } = useContext(ActionContext);
  const config = Config[props.type];
  config.dispatch = dispatch;
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    detail,
    setDetail,
    workflow,
    fieldSetting,
    self
  } = useDetail(props, config);

  const { classes } = props;

  const [isEdit, setIsEdit] = useState(false); // 供应商端编辑状态
  const [isInEdit, setIsInEdit] = useState(false); // 采购方单头编辑状态
  const [isEditLine, setIsEditLine] = useState(false); // 单身编辑状态
  const [currItem, setCurrItem] = useState({}); // 当前编辑的单身
  const [firstCheckItems, setFirstCheckItems] = useState([]); // 优先检验选项
  const [inspectorList, setInspectorList] = useState([]); // 检验员列表
  const [warehouseManList, setWarehouseManList] = useState([]); // 仓管员列表

  //处理详情数据
  self.afterGetDetail = function (data) {
    // 优先检验枚举
    EnumService.getValue('B02_Delivery_Inspect_Enum', data.firstCheck).then(
      value => {
        data.firstCheckName = value;
      }
    );

    //单身枚举
    data.lineList.forEach((item, i) => {
      Util.genExtendFields(item.poLine);
      item.compromiseQtyShow = Big(item.compromiseQty || 0).plus(
        item.subCompromiseQty || 0
      );
      item.refusedQtyShow = Big(item.refusedQty || 0).plus(
        item.subRefusedQty || 0
      );
      EnumService.getValue('B02_Bill_type', item.billType).then(value => {
        item.billTypeName = value;
      });
      EnumService.getValue(
        'B02_Verify_Batch_Determination_Flag',
        item.batchDetermine
      ).then(value => {
        item.batchDecideShow = value;
      });
      if (!Util.isEmpty(item.detailList)) {
        item.detailList.forEach(row => {
          if (typeof row.deductRate === 'number') {
            row.deductRateShow = Big(row.deductRate).times(100).valueOf();
          }
        });
      }
    });
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  // 采购方 - 编辑单头
  async function editHead() {
    // 获取优先检验列表
    if (Util.isEmpty(firstCheckItems)) {
      let list = await EnumService.getItems('B02_Delivery_Inspect_Enum');
      setFirstCheckItems(list);
    }

    // 获取检验员列表
    if (Util.isEmpty(inspectorList)) {
      await CompanyService.getReqEmployeeNameList(companyCode, [
        '10080101',
        '10080102',
        '10080103',
        '10080106',
        '10080107'
      ]).then(rs => {
        let arr = rs.map(item => ({ id: item.userId, text: item.text }));
        setInspectorList(arr);
      });
    }

    // 获取仓管员列表
    if (Util.isEmpty(warehouseManList)) {
      await CompanyService.getReqEmployeeNameList(companyCode, [
        '10030203'
      ]).then(rs => {
        let arr = rs.map(item => ({ id: item.userId, text: item.text }));
        setWarehouseManList(arr);
      });
    }

    setIsInEdit(true);
  }

  // 取消供应商端单头编辑状态
  function cancel() {
    setIsEdit(false);
    self.getDetail();
  }

  // 编辑单身
  function editLine(item) {
    setIsEditLine(true);
    setCurrItem(item);
  }

  // 取消单身编辑状态
  function cancelLine() {
    setIsEditLine(false);
    setCurrItem({});
  }

  // 设置优先检验
  function handleFirstCheckChange(event) {
    setDetail(Object.assign({}, detail, { firstCheck: event.id }));
  }

  // 设置检验员
  function handleInspectorChange(event) {
    setDetail(
      Object.assign({}, detail, {
        employeeId: event.id,
        employeeName: event.text
      })
    );
  }

  // 设置仓管员
  function handleStorekeeperChange(event) {
    setDetail(
      Object.assign({}, detail, {
        storekeeperId: event.id,
        storekeeperName: event.text
      })
    );
  }

  // 采购方保存单头自定义字段
  function saveHeadCustField() {
    // 校验自定义字段
    if (
      !CustFieldService.validate(
        detail,
        [],
        fieldSetting,
        self.isPurchase,
        dispatch
      )
    ) {
      return;
    }

    // 单头提交数据
    let headData = CustFieldService.getHeadData(
      fieldSetting,
      detail,
      self.isPurchase
    );

    let postbody = {
      companyCode: companyCode,
      vfoXkNo: detail.vfoXkNo,
      ...headData,
      apiPath: '/verify/order/updateVo'
    };

    Http.post('/api/cloudCenter?btnId=002', postbody).then(response => {
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
        self.getDetail();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  // 供应商端保存自定义字段
  function updateExtendField() {
    if (self.isPurchase) {
      saveLine();
      return;
    }

    let lineList = isEditLine ? [currItem] : detail.lineList;
    if (
      !CustFieldService.validate(
        detail,
        lineList,
        fieldSetting,
        self.isPurchase,
        dispatch
      )
    ) {
      return;
    }

    let arr = [];
    if (currItem.lineNo) {
      //单身自定义字段
      let bodyData = CustFieldService.getBodyData(
        fieldSetting,
        currItem,
        self.isPurchase
      );
      arr.push({
        lineNo: currItem.lineNo,
        ...bodyData
      });
    }

    let headData = CustFieldService.getHeadData(
      fieldSetting,
      detail,
      self.isPurchase
    );
    let postbody = {
      companyCode: companyCode,
      vfoXkNo: detail.vfoXkNo,
      ...headData,
      lineList: arr,
      apiPath: '/verify/customerOrder/updateExtendField'
    };
    Http.post('/api/cloudCenter?btnId=001', postbody).then(response => {
      if (response.success) {
        setIsEdit(false);
        setIsEditLine(false);
        setCurrItem({});
        ModalService.showTip('保存成功', dispatch);
        self.getDetail();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  // 采购方保存单身
  function saveLine() {
    if (
      isBig(currItem.sampleQty, currItem.verifyQty) &&
      Big(currItem.sampleQty).gt(currItem.verifyQty)
    ) {
      ModalService.showError('抽样数量不能大于送检数量', dispatch);
      return;
    }

    let lineList = [currItem];
    // 校验自定义字段
    if (
      !CustFieldService.validate(
        null,
        lineList,
        fieldSetting,
        self.isPurchase,
        dispatch
      )
    ) {
      return;
    }

    //单身自定义字段
    let bodyData = CustFieldService.getBodyData(
      fieldSetting,
      currItem,
      self.isPurchase
    );

    let postbody = {
      ...currItem,
      ...bodyData,
      detailList: currItem.detailList,
      companyCode: companyCode,
      vfoXkNo: currItem.vfoXkNo,
      apiPath: '/verify/orderLine/save'
    };
    Http.post('/api/cloudCenter?btnId=001', postbody).then(response => {
      if (response.success) {
        setIsEdit(false);
        setIsEditLine(false);
        setCurrItem({});
        ModalService.showTip('保存成功', dispatch);
        self.getDetail();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  // 采购方保存单头
  function save() {
    let postbody = {
      companyCode,
      vfoXkNo: detail.vfoXkNo,
      firstCheck: detail.firstCheck,
      apiPath: '/verify/order/setFirstCheck'
    };
    Http.post('/api/cloudCenter?btnId=003', postbody).then(response => {
      if (response.success) {
        saveInspector();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  // 保存检验员|仓管员
  function saveInspector() {
    let postbody = {
      companyCode: companyCode,
      vfoXkNo: detail.vfoXkNo,
      employeeId: detail.employeeId,
      employeeName: detail.employeeName,
      storekeeperId: detail.storekeeperId,
      storekeeperName: detail.storekeeperName,
      apiPath: '/verify/order/updateVerifyOrder'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        setIsInEdit(false);
        ModalService.showTip('保存成功', dispatch);
        self.getDetail();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  // 文本框变化
  function handleChange(e) {
    let obj = {};
    let key = e.target.name;
    let value = e.target.value;
    obj[key] = value;
    // 抽样数量，送检数量不小于0
    if ((key === 'sampleQty' || key === 'verifyQty') && value < 0) {
      obj[key] = 0;
    }

    // 允收数量联动
    // if (['verifyQty', 'compromiseQty', 'refusedQty'].includes(key)) {
    //   if (
    //     isBig(
    //       value,
    //       currItem.compromiseQty,
    //       currItem.refusedQty,
    //       currItem.subCompromiseQty,
    //       currItem.subRefusedQty
    //     )
    //   ) {
    //     // 允收数量
    //     obj.allowQty = Big(value)
    //       .minus(currItem.compromiseQty)
    //       .minus(currItem.refusedQty)
    //       .minus(currItem.subCompromiseQty)
    //       .minus(currItem.subRefusedQty);
    //     obj.allowQty = obj.allowQty < 0 ? 0 : obj.allowQty;
    //   }
    // }

    setCurrItem(Object.assign({}, currItem, obj));
  }

  // 发送
  function publish() {
    let postbody = getPostbody(config.publishApiPath);
    IqcService.publishIqcOrder(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  // 确认
  function confirm() {
    if (
      !CustFieldService.validate(
        detail,
        detail.lineList,
        fieldSetting,
        true,
        dispatch
      )
    ) {
      return;
    }

    IqcService.confirmIqcOrder(
      self.id,
      () => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  // 退回
  function back() {
    IqcService.backIqcOrder(
      self.id,
      () => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  // 检验完成
  function checkFinish() {
    let postbody = { companyCode: companyCode, vfoXkNo: self.id };
    IqcService.checkFinishIqcOrder(
      postbody,
      () => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  // 显示附件
  function showFileList(item, i, id) {
    const { actions } = props;
    let name =
        id === 1
          ? 'downloadFile1'
          : id === 2
          ? 'downloadFile2'
          : 'downloadFile3',
      businessKey =
        id === 3
          ? item.vfoXkNo + '_' + item.vfoLineNo + '_' + item.lineNo
          : item.vfoXkNo + '_' + item.lineNo,
      businessType = id === 1 ? 15 : id === 2 ? 72 : 95,
      xkNo = item.vfoXkNo,
      lineNo = id === 3 ? item.vfoLineNo : item.lineNo,
      cCode = item[config.companyCodeKey];

    setShowLoading(true);
    CompanyService.getFileList(
      businessType,
      businessKey,
      xkNo,
      lineNo,
      cCode
    ).then(res => {
      setShowLoading(false);
      if (Array.isArray(res)) {
        let arr = res.map(row => {
          return { ...row };
        });
        setFileList(arr);
      }
    });
    actions.openDownloadModal();
  }

  // 获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      vfoXkNo: self.id,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  // 显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  // 重定向
  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                {self.isPurchase && (
                  <li>
                    <span className="field-label">采购方</span>
                    <div className="field-value">{detail.companyName}</div>
                  </li>
                )}
                {!self.isPurchase && (
                  <li>
                    <span className="field-label">客户名称</span>
                    <div className="field-value">
                      {detail[config.vendorNameKey]}
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">来源单据</span>
                  <div className="field-value">{detail.sourceShowNo}</div>
                </li>
                <li>
                  <span className="field-label">送货日期</span>
                  <div className="field-value">
                    {formatDate(detail.sourceDate, 'YYYY-MM-DD')}
                  </div>
                </li>
                {self.isPurchase && (
                  <li>
                    <span className="field-label">供应商</span>
                    <div className="field-value">
                      {detail.innerVendorName}({detail.innerVendorCode})
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">检验单号</span>
                  <div className="field-value">{detail.vfoInnerNo}</div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass(
                          'B02_Verify_Status',
                          detail.status
                        )
                      }
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>

                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">费用单号</span>
                  <div className="field-value">{detail.csoXkNo}</div>
                </li>
                <li>
                  <span className="field-label">制单日期</span>
                  <div className="field-value">
                    {formatDate(detail.createTime, 'YYYY-MM-DD HH:mm')}
                  </div>
                </li>
                <li>
                  <span className="field-label">制单人</span>
                  <div className="field-value">{detail.createName}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="m-details-item">
          <div className="details-item-content">
            <div className="content-line relative">
              <div className="order-detail-title">
                <label>其他信息</label>
              </div>
              <ul className="field-list">
                <li>
                  <span className="field-label">优先检验</span>
                  {isInEdit ? (
                    <div className="field-value w100">
                      <AppSelect
                        value={detail.firstCheck}
                        options={firstCheckItems}
                        change={e => handleFirstCheckChange(e)}
                      ></AppSelect>
                    </div>
                  ) : (
                    <div className="field-value">{detail.firstCheckName}</div>
                  )}
                </li>
                <li>
                  <span className="field-label">检验员</span>

                  {isInEdit ? (
                    <div className="field-value w100">
                      <AppSelect
                        value={detail.employeeId}
                        options={inspectorList}
                        change={e => handleInspectorChange(e)}
                      ></AppSelect>
                    </div>
                  ) : (
                    <div className="field-value">{detail.employeeName}</div>
                  )}
                </li>
                <li>
                  <span className="field-label">仓管员</span>
                  {isInEdit ? (
                    <div className="field-value w100">
                      <AppSelect
                        value={detail.storekeeperId}
                        options={warehouseManList}
                        change={e => handleStorekeeperChange(e)}
                      ></AppSelect>
                    </div>
                  ) : (
                    <div className="field-value">{detail.storekeeperName}</div>
                  )}
                </li>
              </ul>
              {self.isPurchase && (
                <span>
                  <div className={classes.editWrap}>
                    {!isInEdit &&
                      [0, 7].includes(detail.status) &&
                      User.checkAuth('10080112') && (
                        <span
                          className="u-handle u-edit"
                          onClick={() => {
                            editHead();
                          }}
                        >
                          <i className="icon-edit"></i>
                        </span>
                      )}
                  </div>
                  {isInEdit && (
                    <div className="m-flex-box wrap">
                      <span
                        className="m-flex-item u-btn u-btn_primary"
                        onClick={() => {
                          save();
                        }}
                      >
                        保存
                      </span>
                      <span
                        className="m-flex-item u-btn u-btn_line"
                        onClick={() => {
                          setIsInEdit(false);
                        }}
                      >
                        取消
                      </span>
                    </div>
                  )}
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="m-details-item">
          {/* 单头自定义 */}
          <HeadCustField
            fieldSetting={fieldSetting}
            detail={detail}
            setDetail={setDetail}
            isEdit={!self.isPurchase && isEdit}
            showSave={self.isPurchase && [0, 2, 7].includes(detail.status)}
            onSave={saveHeadCustField}
            isPurchase={self.isPurchase}
          ></HeadCustField>
        </div>

        {/*检验单单明细 */}
        {!Util.isEmpty(detail.lineList) && (
          <div className="m-details-item">
            <div className="details-item-title">
              <label>送货明细</label>
            </div>

            <div className="details-item-content">
              {detail.lineList.map((item, index) => (
                <div className="content-line line-list-item" key={index}>
                  <div className="line-list-item-title">
                    <span>项次 {item.lineNo}</span>
                    <div className="more">
                      {((self.isPurchase && item.batchDetermine === null) ||
                        (!self.isPurchase &&
                          User.checkAuth('20030502') &&
                          detail.status === 1)) && (
                        <i
                          className="icon-edit"
                          onClick={() => {
                            editLine(item);
                          }}
                        ></i>
                      )}
                    </div>
                  </div>
                  <ul className="field-list">
                    <li>
                      <span className="field-label">产品编码</span>
                      <div className="field-value">{item.productCode}</div>
                    </li>
                    <li>
                      <span className="field-label">产品名称</span>
                      <div className="field-value">{item.productName}</div>
                    </li>
                    <li>
                      <span className="field-label">产品规格</span>
                      <div className="field-value">{item.productScale}</div>
                    </li>
                    {item.poLine.printExtendFields !== '' && (
                      <li>
                        <span className="field-label">采购说明</span>
                        <div className="field-value">
                          {item.poLine.printExtendFields}
                        </div>
                      </li>
                    )}
                    <li>
                      <span className="field-label">采购单号</span>
                      <div className="field-value">{item.poErpNo}</div>
                    </li>
                    <li>
                      <span className="field-label">订单项次</span>
                      <div className="field-value">{item.poLineNo}</div>
                    </li>
                    <li>
                      <span className="field-label">送货类型</span>
                      <div className="field-value">{item.billTypeName}</div>
                    </li>
                    <li>
                      <span className="field-label">采购交期</span>
                      <div className="field-value">
                        {formatDate(item.sourceDate, 'YYYY-MM-DD')}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">送货数量</span>
                      <div className="field-value">
                        {formatNumber(item.sourceQty, decimalPlace.QTY)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">送检数量</span>
                      <div className="field-value">
                        {formatNumber(item.verifyQty, decimalPlace.QTY)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">抽样数量</span>
                      <div className="field-value">
                        {formatNumber(item.sampleQty, decimalPlace.QTY)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">允收数量</span>
                      <div className="field-value">
                        {formatNumber(item.allowQty, decimalPlace.QTY)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">让步数量</span>
                      <div className="field-value">
                        {formatNumber(item.compromiseQtyShow, decimalPlace.QTY)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">拒收数量</span>
                      <div className="field-value">
                        {formatNumber(item.refusedQtyShow, decimalPlace.QTY)}
                      </div>
                    </li>
                    {!Util.isEmpty(item.fileMd5s) &&
                      item.fileMd5s.length > 0 && (
                        <li>
                          <span className="field-label">附件</span>
                          <div className="field-value">
                            <span
                              className="attachment"
                              onClick={() => showFileList(item, index, 1)}
                            >
                              {item.fileMd5s.length}个附件
                              <i className="icon-attachment"></i>
                            </span>
                          </div>
                        </li>
                      )}
                    {!Util.isEmpty(item.fileMd5s2) &&
                      item.fileMd5s2.length > 0 && (
                        <li>
                          <span className="field-label">内部附件</span>
                          <div className="field-value">
                            <span
                              className="attachment"
                              onClick={() => showFileList(item, index, 2)}
                            >
                              {item.fileMd5s2.length}个附件
                              <i className="icon-attachment"></i>
                            </span>
                          </div>
                        </li>
                      )}
                    <li>
                      <span className="field-label">备注</span>
                      <div className="field-value">{item.remark}</div>
                    </li>
                    <li>
                      <span className="field-label">批次判定</span>
                      <div className="field-value">
                        <span
                          className={
                            item.batchDetermine === 0
                              ? 'green'
                              : item.batchDetermine === 1
                              ? 'red'
                              : item.batchDetermine === 2
                              ? 'gray'
                              : item.batchDetermine === 3
                              ? 'orange'
                              : ''
                          }
                        >
                          {item.batchDecideShow}
                        </span>
                      </div>
                    </li>
                  </ul>
                  <div
                    className={
                      (!self.isPurchase && !item.replyList) ||
                      (self.isPurchase && detail.orderStatus === 1)
                        ? 'order-detail-more hide'
                        : 'order-detail-more'
                    }
                  >
                    <div className="line-list-item-title">不良记录</div>
                    {item.detailList &&
                      item.detailList.map((row, i) => (
                        <ul className="field-list" key={row.id}>
                          <li>
                            <span className="field-label">不良原因</span>
                            <div className="field-value">{row.reasonName}</div>
                          </li>
                          <li>
                            <span className="field-label">不良说明</span>
                            <div className="field-value">
                              {row.badDescription}
                            </div>
                          </li>
                          <li>
                            <span className="field-label">测量值</span>
                            <div className="field-value">
                              {formatNumber(row.measuredValue, detail.QTY)}
                            </div>
                          </li>
                          <li>
                            <span className="field-label">不良数量</span>
                            <div className="field-value">
                              {formatNumber(row.curQty, detail.QTY)}
                            </div>
                          </li>
                          <li>
                            <span className="field-label">收货判定</span>
                            <div className="field-value">
                              {row.operateTypeDesc}
                            </div>
                          </li>
                          <li>
                            <span className="field-label">退货类型</span>
                            <div className="field-value">
                              {row.rejectTypeDesc}
                            </div>
                          </li>
                          <li>
                            <span className="field-label">扣款率</span>
                            <div className="field-value">
                              {row.deductRateShow}%
                            </div>
                          </li>
                          <li>
                            <span className="field-label">处理方式</span>
                            <div className="field-value">
                              {row.processModeStr}
                            </div>
                          </li>
                          <li>
                            <span className="field-label">处理工时</span>
                            <div className="field-value">
                              {row.processHours}小时
                            </div>
                          </li>
                          <li>
                            <span className="field-label">备注说明</span>
                            <div className="field-value">{row.remarkInfo}</div>
                          </li>
                          {!Util.isEmpty(row.fileMd5s) &&
                            row.fileMd5s.length > 0 && (
                              <li>
                                <span className="field-label">附件</span>
                                <div className="field-value">
                                  <span
                                    className="attachment"
                                    onClick={() => showFileList(row, index, 3)}
                                  >
                                    {row.fileMd5s.length}个附件
                                    <i className="icon-attachment"></i>
                                  </span>
                                </div>
                              </li>
                            )}
                        </ul>
                      ))}
                  </div>
                  {/* 单身自定义字段 */}
                  <BodydCustField
                    fieldSetting={fieldSetting}
                    line={item}
                    isPurchase={self.isPurchase}
                  ></BodydCustField>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10080103') &&
            [2, 5, 6].includes(detail.status) &&
            workflow.data &&
            workflow.data['veri_publish_1'].complete && (
              <Button
                type="default"
                onClick={() => {
                  publish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布
              </Button>
            )}

          {User.checkAuth('10080106') && [0, 7].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                checkFinish();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              检验完成
            </Button>
          )}
        </div>
      )}

      {!self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {!isEdit && User.checkAuth('20030502') && detail.status === 1 && (
            <Button
              type="default"
              onClick={() => {
                setIsEdit(true);
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              编辑
            </Button>
          )}

          {isEdit && (
            <Button
              type="default"
              onClick={() => {
                updateExtendField();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              保存
            </Button>
          )}

          {isEdit && (
            <Button
              type="default"
              onClick={() => {
                cancel();
              }}
              className="m-flex-item u-btn u-btn_line"
            >
              取消
            </Button>
          )}

          {!isEdit && User.checkAuth('20030502') && detail.status === 1 && (
            <Button
              type="default"
              onClick={() => {
                confirm();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              确认
            </Button>
          )}

          {!isEdit && User.checkAuth('20030502') && detail.status === 1 && (
            <Button
              type="default"
              onClick={() => {
                back();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              退回
            </Button>
          )}
        </div>
      )}

      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }

      {/* 编辑单身字段 & 单身自定义字段 */}
      {isEditLine && (
        <div>
          <Dialog
            open={isEditLine}
            classes={{ paper: classes.paper }}
            onClose={cancelLine}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">编辑单身字段</DialogTitle>
            <DialogContent>
              {self.isPurchase && (
                <div className="dialog order-detail-item">
                  <div className="line">
                    <span className="order-detail-label">送检数量</span>
                    <div className="field-body">
                      <input
                        type="number"
                        name="verifyQty"
                        value={currItem.verifyQty || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="line">
                    <span className="order-detail-label">抽样数量</span>
                    <div className="field-body">
                      <input
                        type="number"
                        name="sampleQty"
                        value={currItem.sampleQty || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="line">
                    <span className="order-detail-label">允收数量</span>
                    <div className="field-body">
                      <input
                        type="number"
                        name="allowQty"
                        value={currItem.allowQty || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="line">
                    <span className="order-detail-label">让步数量</span>
                    <div className="field-body">
                      <input
                        type="number"
                        name="compromiseQty"
                        value={currItem.compromiseQty || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="line">
                    <span className="order-detail-label">拒收数量</span>
                    <div className="field-body">
                      <input
                        type="number"
                        name="refusedQty"
                        value={currItem.refusedQty || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="line">
                    <span className="order-detail-label">备注</span>
                    <div className="field-body">
                      <input
                        type="text"
                        name="remark"
                        value={currItem.remark || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* 单身自定义字段 */}
              <BodydCustField
                fieldSetting={fieldSetting}
                line={currItem}
                bodyCustData={currItem}
                setBodyCustData={setCurrItem}
                isEdit={true}
                isPurchase={self.isPurchase}
              ></BodydCustField>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={cancelLine}
                className="m-flex-item u-btn u-btn_line"
              >
                取消
              </Button>
              (
              <Button
                onClick={updateExtendField}
                className="m-flex-item u-btn u-btn_primary"
              >
                确定
              </Button>
              )
            </DialogActions>
          </Dialog>
        </div>
      )}

      <Modal></Modal>
    </div>
  );
}

IqcDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(IqcDetail));
